/* ==========================================================================
   COMET header mega-menu — scoped behaviour.
   Only handles the MOBILE tab switching. Desktop panel open/close is handled
   by Prestige's existing <mega-menu-disclosure> (trigger=click via theme
   setting); desktop tile hover blur + "Shop X ->" CTA are pure CSS.
   This file defines a NEW custom element and does not touch any core theme
   class (Drawer / DialogElement / MenuDisclosure / cart-drawer).
   ========================================================================== */
(function () {
  if (window.customElements.get('mega-menu-mobile')) return;

  class MegaMenuMobile extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('.mm-mobile__tab'));
      this.panels = Array.from(this.querySelectorAll('.mm-mobile__panel'));

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.select(tab));
        tab.addEventListener('keydown', (e) => this.onKeydown(e));
      });
    }

    select(tab) {
      const targetId = tab.getAttribute('aria-controls');

      this.tabs.forEach((t) => {
        const active = t === tab;
        t.setAttribute('aria-selected', active ? 'true' : 'false');
        t.setAttribute('tabindex', active ? '0' : '-1');
      });

      this.panels.forEach((p) => {
        p.hidden = p.id !== targetId;
      });

      // keep the newly-active tab in view within the scrollable strip
      tab.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
    }

    onKeydown(e) {
      const idx = this.tabs.indexOf(e.currentTarget);
      if (idx === -1) return;
      let next = null;
      if (e.key === 'ArrowRight') next = this.tabs[idx + 1] || this.tabs[0];
      else if (e.key === 'ArrowLeft') next = this.tabs[idx - 1] || this.tabs[this.tabs.length - 1];
      else if (e.key === 'Home') next = this.tabs[0];
      else if (e.key === 'End') next = this.tabs[this.tabs.length - 1];
      if (next) {
        e.preventDefault();
        this.select(next);
        next.focus();
      }
    }
  }

  window.customElements.define('mega-menu-mobile', MegaMenuMobile);
})();
